/* imports */
import db from 'db'

/* action types */
export const types = {
	IS_LOADING: 'BUNDLE/IS_LOADING',
	FETCH_SUCCESS: 'BUNDLE/FETCH_SUCCESS',
	FETCH_ERROR: 'BUNDLE/FETCH_ERROR',

	UPDATE_SUCCESS: 'BUNDLE/UPDATE_SUCCESS',

	RESET_STATE: 'BUNDLE/RESET_STATE'
};

/* initial state */
export const initialState = {
	isLoading: false,
	error: null,
	bundle: null
};

/* reducer */
export default (state = initialState, action) => {
	switch (action.type) {
		case types.IS_LOADING:
			return { ...state, isLoading: true };

		case types.FETCH_ERROR:
			return {	...state, isLoading: false, error: action.error };

		case types.FETCH_SUCCESS:
			return { ...state, isLoading: false, bundle: action.bundle };

		case types.UPDATE_SUCCESS:
			return { ...state, isLoading: false, bundle: action.bundle };

		case types.RESET_STATE:
			return initialState;

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	isLoading: () => ({ type: types.IS_LOADING }),
	fetchError: error => ({ type: types.FETCH_ERROR, error }),
	fetchSuccess: ({bundle}) => ({ type: types.FETCH_SUCCESS, bundle }),

	updateSuccess: ({bundle}) => ({ type: types.UPDATE_SUCCESS, bundle }),

	resetState: () => ({ type: types.RESET_STATE }),
};

export const dispatchActions = {
	resetBundleHandler: () => dispatch => dispatch(actions.resetState()),

	fetchBundleById: bundleId => dispatch => {
		dispatch(actions.isLoading());

		db.fetchBundleById(bundleId)
			.then(({bundle}) => dispatch(actions.fetchSuccess({bundle})))
			.catch(error => {
				console.log(error);
				dispatch(actions.fetchError(error))
			});
	},

	handleBundleUpdate: (bundle) => dispatch => {
		db.onBundleUpdate(bundle, (bundle) => dispatch(actions.updateSuccess({bundle})));
	}
};


// WEBPACK FOOTER //
// ./src/components/bundle/bundleHandlerRedux.jsx